import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Product } from '@/lib/types';

export interface ProductInput {
    name: string;
    category?: string;
    productCode?: string;
    barcode?: string;
    sku?: string;
    isCategory?: boolean;
    parentId?: string | null;
    attributes?: any;
    sellingPrice: number;
    partyPrice?: number;
    costPrice?: number;
    supplierCost?: number;
    defaultCommission?: number;
    isCommissioned?: boolean;
    stockQuantity?: number;
    lowStockThreshold?: number;
    description?: string;
    unit?: string;
    taxRate?: number;
}

export interface StockAdjustment {
    change: number;
    reason: string;
}

export async function listProducts(shopId: number | string): Promise<Product[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.products.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createProduct(
    shopId: number | string,
    input: ProductInput
): Promise<Product> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.products.CREATE(shopId),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function updateProduct(
    shopId: number | string,
    id: number | string,
    input: Partial<ProductInput>
): Promise<Product> {
    const res = await apiClient.put<{ data: any }>(
        API_ENDPOINTS.products.UPDATE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deleteProduct(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(
        API_ENDPOINTS.products.DELETE(shopId, id),
        { headers: APIHeadersWithAuth() }
    );
}

export async function adjustStock(
    shopId: number | string,
    id: number | string,
    input: StockAdjustment
): Promise<Product> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.products.STOCK(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function recordProductWastage(
    shopId: number | string,
    id: number | string,
    input: { qty: number; note?: string }
): Promise<Product> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.products.WASTAGE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}
